import { AutocompleteSelect } from "../pages/shared/components/Editors";
import IconPopoverDropdown from "./IconPopoverDropdown";

type Opt = { value: string; label: string };

export default function GroupIconDropdown({
  title = "Grupo",
  value,
  defaultVal,
  loadOptions,
  onChange
}: {
  title?: string;
  value?: string;
  defaultVal?: Opt;
  loadOptions: (input: string) => Promise<Opt[]>;
  onChange: (val?: string) => void;
}) {
  const hasSelection = !!value;
  const icon = `far fa-users ${hasSelection ? "text-primary" : "text-muted"}`;

  return (
    <IconPopoverDropdown
      title={title}
      iconClass={icon}
      menuWidth={360}
      value={defaultVal?.label}
    >
      {({ close }) => (
        <div>
          <AutocompleteSelect
            loadOptions={loadOptions}
            onChange={(opt: Opt | null) => {
              onChange(opt?.value);
              close();
            }}
            defaultVal={defaultVal}
          />
        </div>
      )}
    </IconPopoverDropdown>
  );
}
